import React from 'react';

import { IconProps } from './types';

/**
 * Google Calendar's brand mark. Keeps its own colours rather than taking
 * `currentColor` like the glyph icons -- it is artwork, not an icon in the
 * system's palette, so `color` is accepted and ignored.
 *
 * Drawn at 19px inside a 24px box, which is how the design places it.
 */
export const GoogleCalendarIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color: _color, ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="19"
        viewBox="0 0 19 19"
        width="19"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M13.7628 4.27728H4.19885V13.8413H13.7628V4.27728Z"
          fill="white"
        />
        <path
          d="M16.6973 4.57764e-05H13.7616V4.27702H18.0572V1.20604C18.0584 1.20604 17.845 0.11668 16.6973 4.57764e-05Z"
          fill="#1967D2"
        />
        <path
          d="M13.7628 18.1368V18.1473V18.1566L18.0585 13.8796H18.02L13.7628 18.1368Z"
          fill="#1967D2"
        />
        <path
          d="M18.0589 13.8799V13.8409L18.0199 13.8799H18.0589Z"
          fill="#FBBC05"
        />
        <path
          d="M18.0585 4.27728H13.7628V13.8413H18.0585V4.27728Z"
          fill="#FBBC05"
        />
        <path
          d="M18.02 13.8796H13.7628V18.1368L18.02 13.8796Z"
          fill="#EA4335"
        />
        <path
          d="M13.7628 13.8794H18.02L18.0585 13.8409H13.7628V13.8794Z"
          fill="#EA4335"
        />
        <path
          d="M13.7524 18.1488H13.7639V18.1373L13.7524 18.1488Z"
          fill="#34A853"
        />
        <path
          d="M4.19885 13.8409V18.147H13.7523L13.7628 13.8409H4.19885Z"
          fill="#34A853"
        />
        <path
          d="M13.7629 13.8794V13.8409L13.7524 18.147L13.7629 18.1365V13.8794Z"
          fill="#34A853"
        />
        <path
          d="M0 13.8409V16.8349C0.0384892 17.8064 1.08353 18.147 1.08353 18.147H4.19882V13.8409H0Z"
          fill="#188038"
        />
        <path
          d="M4.19882 4.27711H13.7628V0.000137329H1.20483C1.20483 0.000137329 0.0769785 0.116771 0 1.3216V13.8411H4.19882V4.27711Z"
          fill="#4285F4"
        />
        <path
          d="M7.32776 11.9053C7.10895 11.9053 6.89796 11.8766 6.69478 11.8193C6.49682 11.762 6.31448 11.6761 6.14777 11.5615C5.98106 11.4416 5.83259 11.2932 5.70234 11.116C5.57731 10.9389 5.48093 10.7331 5.41321 10.4987L6.37439 10.1158C6.44211 10.3763 6.55673 10.5742 6.71823 10.7097C6.87973 10.8399 7.0829 10.905 7.32776 10.905C7.43716 10.905 7.54135 10.8894 7.64033 10.8581C7.73932 10.8217 7.82528 10.7722 7.89821 10.7097C7.97115 10.6472 8.02845 10.5742 8.07013 10.4909C8.11702 10.4023 8.14046 10.3033 8.14046 10.1939C8.14046 9.96469 8.0545 9.78496 7.88258 9.65472C7.71587 9.52448 7.48405 9.45936 7.18709 9.45936H6.72604V8.52943H7.14802C7.25222 8.52943 7.3538 8.51641 7.45279 8.49036C7.55177 8.46431 7.63773 8.42524 7.71067 8.37314C7.78881 8.31584 7.84872 8.24551 7.8904 8.16215C7.93729 8.07359 7.96073 7.972 7.96073 7.85739C7.96073 7.68026 7.89821 7.53699 7.77318 7.42759C7.64815 7.31298 7.47884 7.25567 7.26524 7.25567C7.03602 7.25567 6.85889 7.31819 6.73386 7.44322C6.61403 7.56304 6.53068 7.69849 6.48379 7.84957L5.54605 7.46666C5.59294 7.33642 5.66327 7.20358 5.75705 7.06812C5.85082 6.92746 5.96804 6.80243 6.1087 6.69303C6.25457 6.57842 6.42388 6.48725 6.61664 6.41952C6.8094 6.34659 7.03081 6.31012 7.28087 6.31012C7.53614 6.31012 7.76797 6.34659 7.97636 6.41952C8.18995 6.49246 8.37229 6.59405 8.52337 6.72429C8.67445 6.84932 8.79167 7.0004 8.87502 7.17753C8.95838 7.34945 9.00005 7.53699 9.00005 7.74017C9.00005 7.89646 8.97922 8.03712 8.93754 8.16215C8.90107 8.28718 8.85158 8.39919 8.78906 8.49817C8.72655 8.59716 8.65361 8.68312 8.57026 8.75605C8.49211 8.82378 8.41136 8.87848 8.32801 8.92016V8.98267C8.57807 9.08166 8.78385 9.24055 8.94535 9.45936C9.11206 9.67816 9.19542 9.95427 9.19542 10.2877C9.19542 10.5221 9.15113 10.7383 9.06257 10.9363C8.97401 11.129 8.84637 11.2984 8.67966 11.4442C8.51816 11.5901 8.3228 11.7021 8.09357 11.7803C7.86435 11.8636 7.60908 11.9053 7.32776 11.9053Z"
          fill="#4285F4"
        />
        <path
          d="M11.0616 11.7803V7.63858L10.116 8.03712L9.7409 7.16971L11.3116 6.43515H12.0852V11.7803H11.0616Z"
          fill="#4285F4"
        />
      </svg>
    );
  },
);
